import {Input} from 'antd'

import {useGetProfile} from 'modules/profile'
import {Form, FormItem, Button, Select} from 'common/components'
import {useInputFocus} from 'common/hooks'
import {FIELD_RULES} from 'common/constants'
import {usePassRequestMilestone} from '..'

interface ControllerReviewFormProps {
  requestUuid: string
  milestone: any
  isConfirm?: boolean
  onClose: () => void
}

export default function ControllerReviewForm({
  requestUuid,
  milestone,
  isConfirm,
  onClose,
}: ControllerReviewFormProps) {
  const {data: profile} = useGetProfile()
  const {
    mutate: passRequestMilestone,
    isMutating: isPassRequestMilestoneMutating,
  } = usePassRequestMilestone(
    requestUuid, 
    !isConfirm ? 'financial-reviewed':'financial-confirm-reviewed',
    onClose
  )
  const inputRef = useInputFocus()

  const handleFinish = (values: any) => {
    const newValues: any = {
      properties: [values.confirm, profile.photo, profile.firstName],
      notes: values.message,
    }
    passRequestMilestone(newValues)
  }

  const initialValues = milestone?.passed
    ? {
        confirm: milestone.properties,
        message: milestone.notes,
      }
    : {
        confirm: 'confirm',
      }

  return (
    <Form initialValues={initialValues} onFinish={handleFinish}>
      <FormItem name="confirm" label="Decision" rules={FIELD_RULES}>
        <Select options={confirmOptions} />
      </FormItem>
      <FormItem name="message" label="Description" rules={FIELD_RULES}>
        <TextArea ref={inputRef} rows={5} />
      </FormItem>
      <Button block htmlType="submit" loading={isPassRequestMilestoneMutating}>
        Save review
      </Button>
    </Form>
  )
}

const {TextArea} = Input

const confirmOptions = [
  {value: 'confirm', label: 'Confirm'},
  {value: 'decline', label: 'Decline'},
]
